<!--  -->
<template>
  <div>
    <el-form :model="formInline" class="demo-form-inline">
      <el-form-item label="选择企业">
        <el-select v-model="formInline.corpId" placeholder="请选择企业" @change="channelShow">
          <el-option
            v-for="item in options"
            :key="item.id"
            :label="item.corpName"
            :value="item.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item v-if="!!formInline.corpId&&title==='pull'" label="选择拉取人员">
        <el-select
          v-model="formInline.user_id"
          filterable
          placeholder="请选择成员"
          default-first-option
          loading-text="加载中"
          :loading="loading"
          @keyup.native="handleSelectChange"
        >
          <el-option
            v-for="item in optionschannel"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </el-form-item>
      <!-- <el-form-item label="群聊名称">
        <el-input v-model="formInline.name" style="width:200px" placeholder="请输入群聊名称" />
      </el-form-item> -->
      <el-form-item>
        <el-button type="primary" @click="suanee">确定</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { enterprisefiltering, feishuAuthAuthPage, feishuChatGetFeiShuUser, feishuChatPullExternalGroup } from '@/api/sourceMaterial.js'
export default {
  components: {},
  props: ['title'],
  data() {
    return {
      formInline: {
        corpId: '',
        user_id: ''
      },
      keywordname: '',
      page: {
        page: 1,
        page_size: 10
      },
      options: [],
      optionschannel: [],
      loading: false,
      timer: null
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    close() {
      this.formInline = {
        corpId: '',
        user_id: ''
      }
      this.keywordname = ''
      this.optionschannel = []
    },
    async handleSelectChange(e) {
      if (this.timer) {
        clearTimeout(this.timer) // 清除之前的计时器
      }
      this.loading = true
      this.timer = setTimeout(async() => {
        console.log(1, e.target.value)
        this.keywordname = e.target.value
        const data = {
          corp_id: this.formInline.corpId,
          name: this.keywordname,
          ...this.page
        }
        const datas = await feishuChatGetFeiShuUser(data)
        this.optionschannel = datas.data.list
        this.loading = false
      }, 1000) // 等待1秒执行
    },
    async channelShow() {
      this.formInline.user_id = ''
      this.optionschannel = []
      const data = {
        corp_id: this.formInline.corpId,
        ...this.page
      }
      const datas = await feishuChatGetFeiShuUser(data)
      this.optionschannel = datas.data.list
      console.log('this.optionschannel :', this.optionschannel)
    },
    send() {
      this.panglist()
    },
    // 获取企业筛选接口
    async panglist() {
      const data = await enterprisefiltering()
      this.options = data.data
      console.log('data', data)
    },
    async suanee() {
      // eslint-disable-next-line eqeqeq
      if (this.formInline.corpId == '') {
        this.$message.error('请选择企业')
        return
      }
      if (this.title === 'authorization') {
        const data = await feishuAuthAuthPage({
          corpId: this.formInline.corpId
        })
        let timer = null
        clearTimeout(timer)
        this.$message({
          type: 'success',
          message: '即将跳转飞书.....'
        })
        timer = setTimeout(() => {
          if (data.data.url) {
            window.open(data.data.url, '_blank')
          }
        }, 1000)
      } else if (this.title === 'pull') {
      // eslint-disable-next-line eqeqeq
        if (this.formInline.user_id == '') {
          this.$message.error('请选择成员')
          return
        }
        await feishuChatPullExternalGroup({
          user_id: this.formInline.user_id,
          corp_id: this.formInline.corpId
        })
        this.$message({
          type: 'success',
          message: '拉取成功'
        })
      }
      this.$emit('createupdata')
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */

</style>
